import axios from 'axios'
import { API_CONFIG, HTTP_STATUS } from './config'
import { ElMessage } from 'element-plus'

// 创建axios实例
const httpClient = axios.create(API_CONFIG)

// 请求拦截器
httpClient.interceptors.request.use(
  config => {
    // 开发环境下打印请求信息
    if (process.env.NODE_ENV === 'development') {
      console.log('API Request:', config.url, config.method, config.data)
    }

    // 添加token
    const token = localStorage.getItem('token')
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }

    return config
  },
  error => {
    console.error('Request Error:', error)
    return Promise.reject(error)
  }
)

// 响应拦截器
httpClient.interceptors.response.use(
  response => {
    // 开发环境下打印响应信息
    if (process.env.NODE_ENV === 'development') {
      console.log('API Response:', response.config.url, response.status, response.data)
    }

    const { data } = response
    if (data.success) {
      return data
    } else {
      const error = new Error(data.message || '请求失败')
      error.code = data.code
      return Promise.reject(error)
    }
  },
  error => {
    console.error('Response Error:', error)

    if (error.response) {
      const { status, data } = error.response

      switch (status) {
        case HTTP_STATUS.UNAUTHORIZED: {
          // 清除认证信息
          localStorage.removeItem('token')
          localStorage.removeItem('userInfo')
          
          // 只在不是登录页面时跳转
          const currentPath = window.location.hash
          if (!currentPath.includes('login')) {
            // 保存当前路径，登录后可以回到这里
            localStorage.setItem('redirectPath', currentPath)
            
            ElMessage.error('登录已过期，请重新登录')
            // 根据当前路径判断跳转到哪个登录页
            if (currentPath.includes('/admin/')) {
              window.location.href = '/#/admin-login'
            } else if (currentPath.includes('/user/')) {
              window.location.href = '/#/user-login'
            } else if (currentPath.includes('/agent/')){
              window.location.href = '/#/agent-login'
            }
          }
          break
        }

        case HTTP_STATUS.FORBIDDEN:
          ElMessage.error('无权限访问')
          break

        case HTTP_STATUS.NOT_FOUND:
          ElMessage.error('请求的资源不存在')
          break

        case HTTP_STATUS.INTERNAL_SERVER_ERROR:
          ElMessage.error('服务器内部错误')
          break

        default:
          ElMessage.error(data?.message || '请求失败')
      }

      return Promise.reject(new Error(data?.message || '请求失败'))
    }

    ElMessage.error(error.message || '网络错误')
    return Promise.reject(new Error(error.message || '网络错误'))
  }
)

export default httpClient
